import { FilterConfigDynamic } from '@/types/filter';
import { toStringOrNull } from '@/utils/cube';

const CUBE_NAME = 'competitor_partner_score';
const DIMENSION = `${CUBE_NAME}.survey_title`;

const competitorSurveyTitleFilter: FilterConfigDynamic = {
  label: 'main.hcpOverview.partnerScore.filter.surveyTitle',
  placeholder: 'main.hcpOverview.partnerScore.filter.surveyTitlePlaceHolder',
  type: 'multiselect',
  defaultValue: [],
  clearable: true,
  searchable: true,
  sourceCube: CUBE_NAME,
  getOptionsQuery: () => ({
    dimensions: [DIMENSION],
    filters: [{ member: DIMENSION, operator: 'set' }],
    order: { [DIMENSION]: 'asc' },
    limit: 10000,
  }),
  mapResult: result => {
    const value = toStringOrNull(result[DIMENSION]);
    if (!value) return null;
    return { value, label: value };
  },
  applyFilter: value => {
    const v = value as string[];
    if (!v?.length) return undefined;
    return { member: DIMENSION, operator: 'equals', values: [...v] };
  },
};

export default competitorSurveyTitleFilter;
